import { render, staticRenderFns } from "./YKDivider.vue?vue&type=template&id=0b00cdde&scoped=true"
var script = {}
import style0 from "./YKDivider.vue?vue&type=style&index=0&id=0b00cdde&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b00cdde",
  null
  
)

export default component.exports